<template>
    <div>
        <van-image-preview
        v-model="open" 
        :images="images" 
        :get-container="getContainer"
        :loop="loop"
        :start-position="startPosition"
        :close-on-popstate="false"
        @change="onChange"
        @close="onClose"
      >
      </van-image-preview>
    </div>
  </template>
  
  <script>
  import { ImagePreview } from 'vant';
  import {mapState} from 'vuex';

  export default {
    name:"ImagePreview",
    components:{
      [ImagePreview.name]: ImagePreview
    },
    props:{
      // 指定挂载的节点
      getContainer:{
        type: String,
        default:""
      }
    },
    data(){
      return {
        open: true,
        // 是否开启循环播放
        loop:false,
        // 切换当前图片时触发
        change:null,
        // 关闭时触发
        close:null,
        // 	关闭且且动画结束后触发
        closed:null,
      }
    },
    computed:{
        ...mapState(['previewImage']),
        images(){
            return this.previewImage.imageList
        },
        startPosition(){
          return this.previewImage.startPosition
        }
    },
    methods:{
      onChange(index){
        if(this.change) this.change(index);
      },
      onClose({ url , index }){
        // if(this.change) this.close({ url , index });
        this.$router.back();
      }
    }
  }
  </script>
  
  <style>
  
  </style>